var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdeaColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3859 41.8541C10.9527 43.1872 9.80159 44.758 8.96437 46.5228L8.52213 47.4553L1.32781 56.5366C1.00531 56.9438 1.0739 57.5352 1.48104 57.8577C1.65382 57.9946 1.85984 58.061 2.06435 58.061C2.34171 58.061 2.61643 57.9388 2.80213 57.7045L10.0629 48.5392C10.1072 48.4834 10.1448 48.4226 10.1754 48.3584L10.6638 47.3289C11.3984 45.7801 12.4088 44.4013 13.667 43.2311C14.0471 42.8774 14.0687 42.2824 13.715 41.902C13.3613 41.5219 12.7663 41.5001 12.3859 41.8541Z",
    fill: "url(#paint0_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0202 35.4871C60.7314 33.9664 58.4461 33.7779 56.9258 35.0665L56.4396 35.4785C56.3258 34.8906 56.0651 34.3231 55.6511 33.8347C54.3626 32.3144 52.0771 32.1258 50.5566 33.4141L50.1253 33.7797C50.0046 33.2104 49.7449 32.6624 49.3426 32.1878C48.054 30.6674 45.7688 30.4789 44.2482 31.7673L37.0199 37.893C36.6488 37.788 36.2579 37.7305 35.8535 37.7305H22.8663C20.4572 37.7305 18.0471 38.3083 15.8968 39.4015C15.4338 39.6368 15.2493 40.203 15.4846 40.6659C15.72 41.1288 16.2861 41.3135 16.749 41.078C18.6368 40.1186 20.752 39.6114 22.8663 39.6114H35.8537C37.1814 39.6114 38.2616 40.6916 38.2616 42.0193C38.2616 42.6727 38.0043 43.2843 37.5373 43.7412C37.0704 44.1978 36.4573 44.4377 35.8011 44.4268C35.7942 44.4267 35.7873 44.4266 35.7803 44.4266H27.3982C26.8787 44.4266 26.4578 44.8475 26.4578 45.367C26.4578 45.8865 26.8787 46.3074 27.3982 46.3074H35.7705C35.7995 46.308 35.8285 46.3083 35.8574 46.3083C36.9838 46.3083 38.0441 45.8763 38.8523 45.0858C38.9708 44.9699 39.0809 44.8479 39.184 44.7213H47.1301C47.9764 44.7213 48.7981 44.42 49.4438 43.8727L58.1418 36.5013C58.8712 35.8833 59.9672 35.9738 60.5854 36.703C61.2034 37.4324 61.1129 38.5286 60.3837 39.1467L46.6529 50.7833C45.3713 51.8693 43.8125 52.5494 42.1447 52.75L40.4506 52.9539C39.935 53.0159 39.5672 53.4841 39.6293 54C39.6867 54.4775 40.0926 54.8281 40.5618 54.8281C40.5994 54.8281 40.6373 54.8257 40.6754 54.8212L42.3694 54.6173C44.4039 54.3727 46.3056 53.5431 47.8688 52.2181L61.5998 40.5815C63.1201 39.293 63.3088 37.0075 62.0202 35.4871ZM45.4642 33.2021C46.1934 32.5839 47.2898 32.6746 47.9079 33.4037C48.4776 34.0759 48.4554 35.0549 47.8619 35.6977L40.1365 42.2449C40.1403 42.1701 40.1425 42.0948 40.1425 42.0193C40.1425 40.779 39.6127 39.6606 38.7682 38.8768L45.4642 33.2021ZM42.3428 42.8405L51.7727 34.849C52.5022 34.2308 53.5983 34.3215 54.2162 35.0506C54.8344 35.78 54.7439 36.8763 54.0146 37.4943L48.2279 42.4379C47.9216 42.6974 47.5316 42.8405 47.1301 42.8405H42.3428Z",
    fill: "url(#paint1_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4558 53.4343L26.8126 54.5944C26.5747 54.6232 26.3566 54.7414 26.2032 54.9252L19.912 62.4566C19.5791 62.8553 19.6323 63.4483 20.0309 63.7812C20.2067 63.9281 20.4205 63.9999 20.6333 63.9999C20.9024 63.9999 21.1694 63.885 21.3555 63.6624L27.4075 56.4172L36.6805 55.3018C37.1961 55.2397 37.564 54.7715 37.502 54.2558C37.4399 53.7402 36.9698 53.3728 36.4558 53.4343Z",
    fill: "url(#paint2_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.988 26.9096C28.988 26.9096 23.4922 18.3542 23.4843 18.3431C22.5541 17.0237 21.9363 15.4837 21.6977 13.8897C21.6209 13.376 21.1416 13.0215 20.6285 13.0989C20.1147 13.1756 19.7608 13.6545 19.8376 14.1681C20.1183 16.0436 20.8434 17.8556 21.9353 19.4098L27.2564 27.6938V29.0653C27.2564 29.4624 27.3965 29.8273 27.6292 30.1139V33.3463C27.6292 34.8591 28.86 36.0901 30.3729 36.0901H33.6906C35.2034 36.0901 36.4344 34.8593 36.4344 33.3463V30.1139C36.6671 29.8273 36.8071 29.4624 36.8071 29.0653V27.6938L42.1283 19.4098C43.5902 17.3289 44.363 14.881 44.363 12.3296C44.363 8.25311 42.3511 4.44467 38.9811 2.14178C35.5386 -0.210645 31.2262 -0.647877 27.1503 0.941929C24.1977 2.09363 21.8366 4.43903 20.6726 7.37689C20.3536 8.18201 20.1096 9.00795 19.9473 9.83175C19.8469 10.3413 20.1787 10.8359 20.6881 10.9363C21.1989 11.0371 21.6923 10.705 21.7927 10.1955C21.9329 9.48367 22.1444 8.76845 22.4213 8.06966C23.3934 5.61605 25.3663 3.65672 27.8339 2.69424C31.3224 1.33364 34.9987 1.69853 37.92 3.69472C40.7763 5.6469 42.4819 8.87491 42.4819 12.3298C42.4819 14.498 41.8238 16.5773 40.5788 18.3431C40.5711 18.3542 35.0751 26.9096 35.0751 26.9096C34.9778 27.0613 34.9261 27.2376 34.9261 27.4179V28.852H34.6963L35.232 19.761H36.1285C37.571 19.761 38.7444 18.5877 38.7444 17.1452V17.0412C38.7444 15.5988 37.571 14.4254 36.1285 14.4254C34.7456 14.4254 33.5984 15.5069 33.5172 16.8875L33.4588 17.8803H30.6133L30.5549 16.8875C30.4736 15.5069 29.3264 14.4254 27.9434 14.4254C26.5009 14.4254 25.3275 15.5988 25.3275 17.0412V17.1452C25.3275 18.5877 26.5009 19.761 27.9434 19.761H28.8401L29.3756 28.852H29.137V27.4179C29.1371 27.2376 29.0853 27.0613 28.988 26.9096ZM35.3949 16.998C35.4177 16.6099 35.74 16.306 36.1287 16.306C36.5339 16.306 36.8637 16.6357 36.8637 17.041V17.1449C36.8637 17.5502 36.5339 17.88 36.1287 17.88H35.3428L35.3949 16.998ZM27.9434 17.8801C27.5381 17.8801 27.2084 17.5503 27.2084 17.1451V17.0411C27.2084 16.6359 27.5381 16.3061 27.9434 16.3061C28.3321 16.3061 28.6545 16.61 28.6773 16.9981L28.7293 17.8802H27.9434V17.8801ZM34.5533 33.3464C34.5533 33.8223 34.1662 34.2094 33.6904 34.2094H30.3727C29.8968 34.2094 29.5098 33.8223 29.5098 33.3464V30.7327H34.5533V33.3464ZM30.7242 19.7609H33.3479L32.8123 28.8519H31.2599L30.7242 19.7609Z",
    fill: "url(#paint3_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3193 13.3509C48.3193 13.8704 48.7403 14.2913 49.2598 14.2913H51.4766C51.9961 14.2913 52.417 13.8704 52.417 13.3509C52.417 12.8314 51.9961 12.4105 51.4766 12.4105H49.2598C48.7403 12.4105 48.3193 12.8315 48.3193 13.3509Z",
    fill: "url(#paint4_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7719 8.37875C47.8803 8.37875 47.9908 8.35981 48.0985 8.31981L50.1771 7.5493C50.6641 7.36887 50.9125 6.82769 50.7321 6.34068C50.5515 5.85367 50.0105 5.60514 49.5234 5.7857L47.4449 6.55622C46.9579 6.73665 46.7095 7.27783 46.8899 7.76484C47.0306 8.14414 47.3898 8.37875 47.7719 8.37875Z",
    fill: "url(#paint5_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4454 20.1457L49.524 20.9161C49.6317 20.956 49.7422 20.9751 49.8506 20.9751C50.2327 20.9751 50.5921 20.7405 50.7325 20.3612C50.9129 19.8742 50.6645 19.3331 50.1775 19.1525L48.0989 18.3821C47.6119 18.2018 47.0708 18.4502 46.8903 18.9371C46.71 19.4241 46.9584 19.9652 47.4454 20.1457Z",
    fill: "url(#paint6_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5869 14.2913H14.8038C15.3233 14.2913 15.7442 13.8704 15.7442 13.3509C15.7442 12.8314 15.3233 12.4105 14.8038 12.4105H12.5869C12.0674 12.4105 11.6465 12.8314 11.6465 13.3509C11.6465 13.8704 12.0674 14.2913 12.5869 14.2913Z",
    fill: "url(#paint7_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8858 7.54942L15.9644 8.31994C16.0721 8.35981 16.1825 8.37887 16.291 8.37887C16.6731 8.37887 17.0323 8.14427 17.1729 7.76497C17.3533 7.27796 17.1049 6.7369 16.6179 6.55634L14.5394 5.78583C14.0526 5.60564 13.5114 5.85379 13.3307 6.3408C13.1504 6.82781 13.399 7.36886 13.8858 7.54942Z",
    fill: "url(#paint8_linear_472_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.173 18.9371C16.9926 18.4501 16.4515 18.2016 15.9644 18.3821L13.8858 19.1525C13.3988 19.333 13.1504 19.8741 13.3308 20.3612C13.4714 20.7403 13.8305 20.9751 14.2127 20.9751C14.3211 20.9751 14.4316 20.9561 14.5393 20.9161L16.6179 20.1457C17.105 19.9652 17.3535 19.4241 17.173 18.9371Z",
    fill: "url(#paint9_linear_472_92)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_92",
    x1: 1.97339,
    y1: 43.5777,
    x2: 13.3419,
    y2: 60.9369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_92",
    x1: 18.5216,
    y1: 33.7825,
    x2: 27.2203,
    y2: 67.5873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_472_92",
    x1: 20.871,
    y1: 54.6966,
    x2: 25.2956,
    y2: 69.2879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_472_92",
    x1: 21.449,
    y1: 4.33174,
    x2: 47.572,
    y2: 39.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_472_92",
    x1: 48.5902,
    y1: 12.6362,
    x2: 49.2204,
    y2: 15.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_472_92",
    x1: 47.0928,
    y1: 6.04511,
    x2: 48.3171,
    y2: 9.62276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_472_92",
    x1: 47.0933,
    y1: 18.6416,
    x2: 48.3174,
    y2: 22.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_472_92",
    x1: 11.9173,
    y1: 12.6362,
    x2: 12.5475,
    y2: 15.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_472_92",
    x1: 13.5337,
    y1: 6.04537,
    x2: 14.7579,
    y2: 9.62284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_472_92",
    x1: 13.5337,
    y1: 18.6415,
    x2: 14.7579,
    y2: 22.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaColor);
export default __webpack_public_path__ + "static/media/ideaColor.da35f3404b43528530bd11946ba48fca.svg";
export { ForwardRef as ReactComponent };